<script lang="ts">
  import { fly } from 'svelte/transition';
  import { getTabContext } from './Tabs.svelte';

  const props = $props();
  let clientWidth = $state(0);
  const tabs = getTabContext();
</script>

<div class="tab-panel-container" bind:clientWidth>
  {#each tabs.tabs as tab}
    {#if tabs.selected.current === tab}
      <div
        class="tab-panel"
        in:fly={{
          x: (tabs.direction ? 1 : -1) * clientWidth,
          duration: 500,
          opacity: 1,
        }}
        out:fly={{
          x: (tabs.direction ? -1 : 1) * clientWidth,
          duration: 500,
          opacity: 1,
        }}
      >
        {@render props.children()}
      </div>
    {/if}
  {/each}
</div>

<style>
  .tab-panel-container {
    display: grid;
  }
  .tab-panel {
    height: 100%;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
  }
</style>
